<template>
  <div class="container py-4">
    <h1 class="h3 fw-semibold mb-3">
      My Requests
    </h1>
    <div class="list-group">
      <div v-if="tickets.length === 0" class="list-group-item text-center text-muted py-4">
        No pending requests
      </div>
      <div v-for="t in tickets" :key="t.id || t.donation_item_id"
        class="list-group-item d-flex justify-content-between">
        <div>
          <div class="fw-semibold">
            {{ t.unique_qr_code }} — {{ t.status || t.submission_status }}
          </div>
          <div class="text-muted small">
            {{ formatSanDiegoDateTime(t.created_at) }} • {{ t.location }}
          </div>
        </div>
        <div>
          <router-link :to="{
            name: 'MyDonationDetail',
            params: { qr: t.unique_qr_code }
          }" class="btn btn-sm btn-dark">
            Open
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { formatSanDiegoDateTime } from '../utils/dateTime';
import { ref, onMounted } from 'vue';
import axios from 'axios';

const tickets = ref([]);
const userType = ref('');

function getPayload() {
  const token = sessionStorage.getItem('token');
  if (!token) return null;
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
}

async function load() {
  try {
    const payload = getPayload();
    if (!payload) return;

    userType.value = payload.userType;

    const endpoint = '/api/my/donations';


    const { data } = await axios.get(
      `${process.env.VUE_APP_API_URL}${endpoint}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    tickets.value = data.filter(ticket => ticket.submission_status !== 'Fulfilled');
  } catch (err) {
    console.error('Failed to load donations:', err);
  }
}


// async function confirm(qr, needsMore) {
//   await axios.post(`${process.env.VUE_APP_API_URL}/api/donations/${qr}/confirm`, {
//     needs_more: needsMore,
//     note: needsMore ? 'Need more items' : 'Received'
//   });
//   await load();
// }

onMounted(load);
</script>